import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TwoWayService } from './two-way.service';
import { CustomThemeService } from "./custom-theme.service";

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [

  ],
  providers: [
    TwoWayService,
    CustomThemeService
  ]
})
export class ServiceModule { }
